// Maja's per-unit tip text. Used on the Home screen's tip bubble.
// Falls back to a generic tip if the skill ID isn't listed.

const tips = {
  greetings: {
    sv: 'Bok! Vi börjar med hej, hej då, tack och varsågod — de räddar dig första veckan i Split. 😎',
    en: "Bok! We start with the hellos, goodbyes, and pleasantries — they'll get you through your first week in Split. 😎",
  },
  'pronouns-tobe': {
    sv: 'Jag är, du är, hon är… kroatiskan har många former. Lugn, du lär dig dem snabbt.',
    en: "I am, you are, she is… Croatian has lots of forms. Don't worry, they stick fast.",
  },
  people: {
    sv: 'Människor och titlar. Bra att kunna när du beställer kaffe åt din nya prijatelj.',
    en: "People and titles. Handy when you're ordering coffee for your new prijatelj.",
  },
  family: {
    sv: 'Familjen kommer alltid att fråga: "Govoriš li hrvatski?" Nu kan du svara.',
    en: 'Family will always ask: "Govoriš li hrvatski?" Now you can answer back.',
  },
  'numbers-1-10': {
    sv: 'Jedan, dva, tri… om du kan räkna till tio kan du beställa hur många piva du vill.',
    en: 'Jedan, dva, tri… know your tens and you can order as many pivas as you like.',
  },
  colors: {
    sv: 'Färger på kroatiska böjer sig med substantivet. Men nu, bara orden — vi tar grammatiken sen.',
    en: "Croatian colors decline with the noun. But right now — just the words. Grammar later.",
  },
  food: {
    sv: 'Mat & dryck. Den viktigaste lektionen, säg jag som lever på kava och kruh.',
    en: 'Food & drinks. The most important lesson — I survive on kava and kruh.',
  },
  animals: {
    sv: 'Djur! Pas är hund, mačka är katt. Nu kan du smågrymta åt vilken kroatisk hund som helst.',
    en: 'Animals! Pas is dog, mačka is cat. Now you can baby-talk to any Croatian dog.',
  },
  'verbs-basic': {
    sv: 'Verb — det viktigaste i alla språk. Lär dig dessa så bygger du meningar nästan direkt.',
    en: 'Verbs — the engine of any language. Lock these in and you can build sentences immediately.',
  },
  house: {
    sv: 'Hus, kök, sovrum. För när du hyr en stuga på Hvar och behöver fråga var kaffemaskinen är.',
    en: 'House, kitchen, bedroom. For when you rent a place on Hvar and need the coffee machine.',
  },
  'sentences-1': {
    sv: 'Riktiga meningar! "Drago mi je" = "trevligt att träffas". Nu blir det på riktigt.',
    en: '"Drago mi je" = "nice to meet you". Real sentences. Real Croatian.',
  },
  'numbers-11-100': {
    sv: 'Större tal. Tjugo, trettio, hundra. Vägen till "Koliko košta?" (hur mycket?).',
    en: 'Bigger numbers. Twenty, thirty, a hundred. The path to "Koliko košta?" (how much?).',
  },
  'time-words': {
    sv: 'Idag, igår, imorgon. Bra ord för att skylla på att du glömt en lektion. Inte att jag dömer.',
    en: 'Today, yesterday, tomorrow. Useful words for explaining why you skipped yesterday. Not that I judge.',
  },
  days: {
    sv: 'Veckodagar. Petak (fredag) är favoriten. Vinet börjar redan på torsdag, dock.',
    en: 'Days of the week. Petak (Friday) is the favorite. Though the wine starts on Thursday.',
  },
  months: {
    sv: 'Månaderna. Kroatiska månadsnamn har inget med engelska att göra. Siječanj? Det är januari. Verkligen.',
    en: 'Months. Croatian months have nothing to do with English. Siječanj? That\'s January. Really.',
  },
  weather: {
    sv: 'Väder. Pada kiša = det regnar. Sunce = sol. Vi har båda — välkommen till Adriatiska kusten.',
    en: 'Weather. Pada kiša = it\'s raining. Sunce = sun. We get both — welcome to the Adriatic.',
  },
  travel: {
    sv: 'Resa! Hotell, biljett, pass. Du är så nära din första kroatiska semester nu.',
    en: 'Travel! Hotel, ticket, passport. You\'re so close to your first Croatian holiday.',
  },
  restaurant: {
    sv: 'På restaurang. Beställ, ät, be om notan. Du klarar dig nästan utan engelska nu.',
    en: 'At the restaurant. Order, eat, pay. You can almost get by without English now.',
  },
  accusative: {
    sv: 'Akkusativ. Slaviska kasus är knepiga — börja med detta. -a → -u för feminint.',
    en: "Accusative case. Slavic cases are tricky — start with this one. -a → -u for feminine.",
  },
  'past-tense': {
    sv: 'Dåtid. "Bio sam" / "bila sam" — beroende på kön. Slaviska språk gör skillnad.',
    en: '"Bio sam" / "bila sam" — gendered past tense. Slavic languages keep score.',
  },
  'travel-phrases': {
    sv: 'Fraser för resan. "Gdje je toalet?" är troligen den viktigaste meningen vi lär dig.',
    en: '"Gdje je toalet?" is probably the most important sentence we\'ll teach you.',
  },
};

export function tipFor(skillId, lang = 'sv') {
  const tip = tips[skillId];
  if (tip) return tip[lang] || tip.sv;
  return lang === 'en'
    ? 'New unit! Tap a node to dive in. I\'ll be here with hints when you need them. 💪'
    : 'Ny lektion! Tryck på en nod för att börja. Jag finns här när du fastnar. 💪';
}
